const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50MB in bytes

const email = {
  maxFileSize: MAX_FILE_SIZE,
  serviceId: import.meta.env.VITE_EMAILJS_SERVICE_ID,
  serviceId2: import.meta.env.VITE_EMAILJS_CUSTOMER_SERVICE_ID,
  templateId: import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
  templateId2: import.meta.env.VITE_EMAILJS_CUSTOMER_TEMPLATE_ID,
  sendTacherInvitationTemplateId: import.meta.env
    .VITE_EMAILJS_TEACHER_INVITE_DI,
  studentPasswordResetOTPTemplateId: import.meta.env
    .VITE_EMAILJS_STUDENT_RESET_PASSWORD_ID,
  publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY,
  classNotificationServiceId: import.meta.env.VITE_EMAILJS_CUSTOMER_SERVICE_ID,
  classNotificationTemplateId: import.meta.env
    .VITE_EMAILJS_CUSTOMER_TEMPLATE_ID,
  verificationTemplateId: import.meta.env.VITE_EMAILJS_VERIFICATION_TEMPLATE_ID,
  passwordResetTemplateId: import.meta.env
    .VITE_EMAILJS_PASSWORD_RESET_TEMPLATE_ID
}

// Security Note: EmailJS public key, service ID, and template ID are designed
// to be exposed in client-side code. These are public identifiers, not secrets.
// The public key is used for client-side authentication with EmailJS API.
// Service ID and Template ID are public identifiers for routing emails.
// This is the standard and secure way to use EmailJS.

export default email
